<template>
  <div>
    <iframe
      src="https://xdwlgl.ysy.crtvup.com.cn"
      frameborder="0"
      width="100%"
      :height="windowHeight"
    ></iframe>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  components: { Footer },
  data() {
    return {
      windowHeight: 500,
    };
  },
  created() {
    this.windowHeight = document.documentElement.clientHeight;
  },

  mounted() {},
  methods: {},
};
</script>
